import React, {useContext, useEffect, useState} from 'react';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {makeStyles} from '@material-ui/core/styles';
import {useMediaQuery} from '@material-ui/core';

import TipsList from '../TipsList';

import _firebaseContext from '../../../contexts/firebaseContext';
import _appContext from '../../../contexts/appContext';

const TipsLanguagesPanel = () => {
    const [tipsLanguages, setTipsLanguages] = useState([]);
    const [currentTipsLanguageIndex, setCurrentTipsLanguageIndex] = useState(0);
    const classes = useStyles();
    const mobileResolution = useMediaQuery('(max-width:767px)');

    const firebaseContext = useContext(_firebaseContext);
    const appContext = useContext(_appContext);
    const isLoading = appContext.loading;

    const getLanguagesList = () => firebaseContext.getLanguages().catch((e) => console.log('getLanguagesList: ', e));
    const getTipsLanguagesList = () => firebaseContext.getTipsLanguages()
        .then(async tipsLanguages => {
            const languagesList = await getLanguagesList();
            const result = [];

            if (tipsLanguages.length) {
                tipsLanguages.forEach(tip => {
                    const localeId = tip.id.split('_').reverse()[0];
                    let localeIndex = languagesList.findIndex(language => language.id === localeId);
                    if (localeIndex === -1) {
                        return false;
                    }

                    const language = languagesList[localeIndex];
                    if (!language) {
                        return appContext.snackbar.showSnackbarMsg('Произошла ошибка, не удалось найти требуемый язык');
                    }
                    const localeName = language.data.represent;
                    const localeIdentifier = language.data.languageId;

                    return result.push(Object.assign(tip, {localeName, localeIdentifier}));
                });
            }

            result.sort(a => {
                const name = a.localeIdentifier.toLowerCase();
                return (name !== 'ru') ? 1 : -1;
            });

            return setTipsLanguages(result);
        })
        .catch((e) => console.log('getTipsLanguagesList: ', e));

    useEffect(() => {
        (async () => {
            appContext.startLoading();
            await getTipsLanguagesList();
            appContext.endLoading();
        })();
    }, []);

    return (
        <>
            <div className={classes.root}>
                <div className={classes.planetsListTitle}>
                    <Typography
                        className={classes.tabsTitle}
                        color='textSecondary'
                    >
                        Список языков
                    </Typography>
                </div>

                {
                    !isLoading &&
                    <div className={`${classes.tabsWrapper} ${mobileResolution ? classes.column : classes.row}`}>
                        {
                            tipsLanguages.length === 0 ? (
                                <Typography variant='body1'>
                                    В системе пока нет данных
                                </Typography>
                            ) : (
                                <>
                                    <Tabs
                                        orientation={mobileResolution ? 'horizontal' : 'vertical'}
                                        variant='scrollable'
                                        onChange={(event, value) => setCurrentTipsLanguageIndex(value)}
                                        value={currentTipsLanguageIndex}
                                        className={classes.tabs}
                                    >
                                        {
                                            tipsLanguages.map(tip => (
                                                <Tab key={tip.id} label={tip.localeName}/>
                                            ))
                                        }
                                    </Tabs>
                                    <TipsList languageTips={tipsLanguages[currentTipsLanguageIndex]}/>
                                </>
                            )
                        }
                    </div>
                }
            </div>
        </>
    );
}

const useStyles = makeStyles(theme => ({
    root: {
        minHeight: 500
    },
    tabsWrapper: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        display: 'flex'
    },
    column: {
        flexDirection: 'column'
    },
    row: {
        flexDirection: 'row'
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`
    },
    tabsTitle: {
        display: 'block',
        marginTop: '15px',
        marginBottom: '15px'
    },
    planetsListTitle: {
        display: 'flex',
        alignItems: 'center'
    }
}));

export default TipsLanguagesPanel;
